import {react,useState,useEffect}from "react";
import "./css/BannerS.css";
import "./css/LatestNews.css";
import "./css/Admission.css";
import "./css/HlastSection.css";
import { NavLink } from "react-router-dom";



// card code carouselContent
// const carouselContent = [
//   {
//     image: "/images1/KB2.jpg",
//     alt: "First slide",
//     heading: "The Katara Hills School",
//     paragraph:
//       "Embracing state-of-the-art technology in our classrooms allows The Katara Hills School to facilitate 21st century teaching and learning for its teachers and students.",
//     captionStyle: {},
//   },
//   {
//     image: "/images1/K3.jpg",
//     alt: "Second slide",
//     heading: "Dynamic Educators",
//     paragraph:
//       "The Katara Hills School to facilitate 21st century teaching and learning for its teachers and students.",
//     captionStyle: { color: "black" },
//     paragraphStyle: { color: "#262624" },
//   },
//   {
//     image: "/images1/KB1.JPG",
//     alt: "Third slide",
//     heading: "Hands-on learning",
//     paragraph:
//       "Since its inception, HIS has consistently grown year after year and has gained a reputation of becoming a leading educational institute.",
//     captionStyle: {},
//   },
//   // Add more slides as needed
// ];

const BannerSection = () => {
  const [sliderdata,setSliderdata]=useState('')
  const [loading,setLoading] = useState('loading')
  const [content, setContent] = useState([
    {
      image: "/images1/KB1.JPG",
      alt: "Third slide",
      heading: "Third slide",
      paragraph:
        "Since its inception, HIS has consistently grown year after year and has gained a reputation of becoming a leading educational institute.",
      captionStyle: {},
    },
  ]);



  useEffect(() => {
    const fetchSliderdata = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_PROJECT_PATH}/items/homeslider?fields=*.*.*`,
         
    
          {cache: 'no-store',});
        const data = await response.json();

       setSliderdata(data.data || []);


         const slidesFromAPI = (data.data || []).map((item) => ({
          image: item.image?.data?.full_url
            ? item.image.data.full_url.replace("http://", "https://")
            : "", // fallback if no image
          alt: item.title || "Slide image",
          heading: item.title || "",
          paragraph: item.description || "",
          captionStyle: {},
        }));

        setContent(slidesFromAPI);
        
      } catch (err) {
        console.error("Error fetching images:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSliderdata();
  }, []);
useEffect(() => {
 
}, [content]);
 

  return (
    <>

    {/* optimised code 13-05-2025 */}
    <div className="container-fluid p-0">
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-ride="carousel"
      >
        <ol className="carousel-indicators">
          {content.map((_, index) => (
            <li
              key={index}
              data-target="#carouselExampleIndicators"
              data-slide-to={index}
              className={index === 0 ? "active" : ""}
            ></li>
          ))}
        </ol>

        <div className="carousel-inner" role="listbox">
          {content.map((item, index) => (
            <div
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              key={index}
            >
              <img
                className="d-block slideimage"
                src={item.image}
                alt={item.alt}
              />
              <div
                className="carousel-caption d-none d-md-block"
                style={item.captionStyle}
              >
                <h1 style={item.captionStyle}>
                  <b>{item.heading}</b>
                </h1>
                <p>
                  <b style={item.paragraphStyle || {}}>{item.paragraph}</b>
                </p>
              </div>
            </div>
          ))}
        </div>

        <a
          className="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span
            className="carousel-control-prev-icon jj"
            aria-hidden="true"
          ></span>
          <span className="sr-only"></span>
        </a>
        <a
          className="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span
            className="carousel-control-next-icon jj"
            aria-hidden="true"
          ></span>
          <span className="sr-only"></span>
        </a>
      </div>
    </div>


    

      {/* Latest New Section---------------------- */}
    
      <div className="container-fluid p-0">
        <h1 className="heading1 ada">Facilities</h1>

        <div className="container-fluid px-5 d-flex latest_card_box">
          <div className="lnewsleft p-3">
            <div className="card_img1">
              <img src="./images1/K3.jpg" alt="" />
            </div>
            <div className="title">
              <h3 className="my-3 ak">Science Technology</h3>
              <p>
                A school Science Technology offers an important added value to an
                educational centre. More information here....
              </p>
            </div>
          </div>
          <div className="lnewsmid p-3">
            <div className="card_img1">
              <img src="./images1/KB1.JPG" alt="" />
            </div>
            <div className="title">
              <h3 className="my-3 ak">Skilled Staff</h3>
              <p>
                Skilled Staff is here to teach or guide for your bright carrier
                and and provides Handson in our School.Teachers play a key role
                in identifying and supporting students...
              </p>
            </div>
          </div>
          <div className="lnewsright p-3">
            <div className="card_img1">
              <img src="./images1/g3.webp" alt="" />
            </div>
            <div className="title">
              <h3 className="my-3 ak">Sports</h3>
              <p>
                The The Katara Hills School won the Many Award! Remember
                how hard our school worked together on physical activity,
                healthy eating, and mental. Specialy Focus on Education and
                Sports.
              </p>
            </div>
          </div>
        </div>

        <div className="latestbutton p-2">
          <NavLink className="btn btn-lg kop viewbtn" to="/facilities">
            View all New
          </NavLink>
        </div>
      </div>

      {/* Admission Section ---------- */}

      <div className="container-fluid mt-3 p-0">
        <div className="container-fluid d-flex latest_card_box_ad p-0">
          <div className="ladmleft p-5 text-center">
            <div className="title">
              <h1 className="my-3 lnns">
                Our <span style={{ color: "yellow" }}>School</span>
              </h1>
              <p>
                The Katara Hills School provides a value-based learning
                environment with a commitment of using modern day teaching
                pedagogy to cultivate an advanced and comprehensive academic
                program; fully compliant with the Hogwarts curriculum of
                studies. We are a K to 8 school with a wide array of resources
                designed to foster student achievement that will prepare our
                pupils to pursue higher education and be competitive in their
                careers.
              </p>
            </div>
            <div className="readbutton p-2">
              <NavLink className="btn btn-lg bg-warning adm" to="/ourschool">
                Read More
              </NavLink>
            </div>
          </div>

          <div className="ladmright p-5 text-center">
            <div className="title">
              <h1 className="my-3 lnns">
                <span style={{ color: "yellow" }}>
                  The Katara Hills School{" "}
                </span>
                Admission
              </h1>
              <p className="mt-3">
                The The Katara Hills School gives a fair and equal chance
                to all applicants who fulfill the admission requirements;
                dependent upon space availability. To determine admission
                eligibility for students transferring from another school,
                official report cards as well as other supporting documents are
                submitted upon application.
              </p>
            </div>
            <div className="readbutton p-2">
              <NavLink
                className="btn btn-lg bg-warning adm mt-3"
                to="/academicprocedure"
              >
                Read More
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      {/* Home LAst Section ------------ */}

      <div className="container-fluid p-0">
        <div className="container-fluid p-0  d-flex latest_card_box_hls">
          <div className="hlsleft">
            <div className="ccc1_img">
              <img src="./images1/home1.webp" alt="" />
            </div>
            <div className="ccc2_img">
              <img src="./images1/home2.webp" alt="" />
            </div>
          </div>
          <div className="hlsmid text-center p-5">
            <div className="card_imgl my-5">
              <img src="./images1/hlogo1.png" alt="" />
            </div>
            <div className="title1 my-5">
              <div className="hlstbutton1">
                <NavLink
                  className="btn btn-lg kop kophl text-nowrap"
                  to="/gallery"
                  style={{ backgroundColor: "#2E63B1", color: "white" }}
                >
                  Student Life
                </NavLink>
                <NavLink
                  className="btn btn-lg kop  kophl text-nowrap"
                  to="/academicprocedure"
                  style={{ backgroundColor: "#1D4776", color: "white" }}
                >
                  Admission
                </NavLink>
              </div>
            </div>

            <p>
              At the The Katara Hills School, we believe in giving our
              students a voice and instilling in them a passion to be involved
              with their school community. It is evident that students are at
              the forefront of understanding the needs of making their school
              into an environment that promotes a safe and healthy learning
              environment. For this reason, The Katara Hills School is
              committed in providing a well balanced spiritual, academic and
              social well-being experience for it’s students. Students are
              encouraged to hone their talents in order to serve and participate
              in and beyond our community.
            </p>
            <div className="title1">
              <div className="hlstbutton">
                <NavLink
                  className="btn btn-lg hls px-4 py-3"
                  to="/facilities"
                  style={{ backgroundColor: "#2E63B1", color: "white" }}
                >
                  Learn More
                </NavLink>
              </div>
            </div>
          </div>
          <div className="hlsright">
            <div className="ccc2_img">
              <img src="./images1/home3.webp" alt="" />
            </div>
            <div className="ccc1_img">
              <img src="./images1/yog.jpeg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerSection;
